<template>
  <article class="m-card-element m-card-element-design-proyect-2">
    <div class="m-card-element-info-data">
      <img
        v-if="proyecto.imagen"
        id="tarjetaImagen"
        :src="proyecto.imagen"
      >
      <img
        v-else
        id="tarjetaImagen"
        src="@/assets/img/ds2.png"
      >
      <h5
          v-if="proyecto.publicado"
          key="available"
        >
          PUBLICADO
        </h5>
        <h5
          v-else
          key="notAvailable"
        >
          BORRADOR
        </h5>
      <h2 class="m-card-element-design-2-name">
        {{ proyecto.titulo }}
      </h2>
    </div>
  </article>
</template>
<script>
export default {
  name: 'MoleculeEditionBillingAcademyProyectCard2',
  props: {
    proyecto: Object
  }
}
</script>
